'use client';

import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// Reusable FAQ Button Component
const FAQButton = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={onClick}
        className={`flex justify-between w-full px-4 py-3 text-left focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75
          text-gray-600 bg-gray-50 hover:bg-emerald-50 rounded-lg 
          text-base md:text-lg lg:text-base`}
        style={{
          fontSize: '1rem',
          color: '#000000',
          fontFamily: 'Roboto, sans-serif',
          lineHeight: '1.5',
          margin: '0 0 10px',
        }}
      >
        <span>{question}</span>
        <span className="text-gray-500">{isOpen ? '-' : '+'}</span>
      </button>
      {isOpen && (
        <div
          className="mt-2 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg"
          style={{
            fontSize: '1rem',
            color: '#000000',
            fontFamily: 'Roboto, sans-serif',
            lineHeight: '1.5',
            margin: '0 0 10px',
          }}
        >
          {answer}
        </div>
      )}
    </div>
  );
};

// Main Component for FAQ Section
function HomePageFaqsList() {
  const faqsList = [
    { question: "What facial services do you offer?", answer: "We provide rejuvenating facials tailored to your skin type, including cleansing, exfoliation, and hydration, delivered right to your doorstep." },
    { question: "How do I book a facial service?", answer: "Simply visit Door to Door Beauty's website or call us to schedule a convenient time for your at-home facial treatment." },
    { question: "Are your makeup artists certified?", answer: "Yes, Door to Door Beauty employs certified and experienced makeup artists to ensure high-quality and professional service." },
    { question: "Do you bring all the makeup products?", answer: "Absolutely! Our artists arrive fully equipped with premium makeup products and tools to create your desired look seamlessly." },
    { question: "What types of waxing services do you provide?", answer: "Door to Door Beauty offers full-body, facial, and specific area waxing services, ensuring smooth, hair-free skin with gentle and hygienic techniques." },
    { question: "Is waxing performed using high-quality products?", answer: "Yes, we use premium waxing products that are safe for all skin types, providing a comfortable and effective hair removal experience at your doorstep." },
    { question: "Do you offer facials for all skin types?", answer: "Yes, Door to Door Beauty provides customized facials tailored to suit all skin types, addressing specific concerns like hydration, anti-aging, or acne." },
    { question: "How long does a facial session take?", answer: "A typical facial session lasts 45-60 minutes, offering a relaxing and rejuvenating experience delivered right to your home." },
    { question: "What services does your hair studio provide?", answer: "Door to Door Beauty offers haircuts, styling, coloring, and treatments to keep your hair healthy and looking fabulous—all from the comfort of your home." },
    { question: "Do you use professional hair care products?", answer: "Yes, we use top-quality, salon-grade products to ensure your hair receives the best care and stunning results." },
    { question: "Does DTDB at Home in Noida offer a full range of salon and beauty services?", answer: "Yes, DTDB at Home offers a wide range of salon and beauty services, including hair care, skincare, makeup, waxing, and more, right at your doorstep." },
    { question: "Are the beauticians at your home salon in Noida trustworthy and professional?", answer: "Absolutely! Our beauticians are highly trained, experienced, and background-verified to ensure a safe and professional experience." },
    { question: "Is it possible to request the same beautician for future appointments in Noida?", answer: "Yes, you can request the same beautician for your next appointment based on availability, ensuring consistency in service." },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const language = useSelector((state) => state.language.language);
  const text = {
    FaqTitle: language === "en" ? "Frequently Asked Questions" : "आप क्या खोज रहे हैं?",
  };

  return (
    <div className="bg-gray-100 lg:py-16 py-10 -mt-9">
      <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
        <div className="mb-10 flex justify-center">
          <div className="text-center w-full lg:w-4/5">
            <h2
              className="text-xl lg:text-2xl mb-2 font-semibold text-black"
              style={{
                fontSize: '1.4rem',
                fontFamily: 'Roboto, sans-serif',
              }}
            >
              {text.FaqTitle}
            </h2>
          </div>
        </div>

        {/* FAQ List using Tailwind Grid */}















       {<div className="flex flex-col md:flex-row gap-6">
      {/* Left Column */}
      <div className="flex flex-col gap-6 w-full md:w-1/2">
        {faqsList
          .filter((_, idx) => idx % 2 === 0)
          .map((product, mapIdx) => {
            const originalIdx = mapIdx * 2;
            return (
              <FAQButton
                key={originalIdx}
                question={product.question}
                answer={
                  <>
                    {product.answer && <p>{product.answer}</p>}
                    {Array.isArray(product.data) && product.data.length > 0 && (
                      <ul
                        style={{
                          fontSize: '1rem',
                          color: '#000',
                          fontFamily: "'Roboto', sans-serif",
                          lineHeight: '1.625',
                          margin: '0 0 10px',
                          paddingLeft: '40px',
                          listStyleType: 'decimal',
                        }}
                      >
                        {product.data.map((item, i) => (
                          <li key={i} style={{ marginBottom: '10px' }}>
                            <strong>{item.title}</strong> {item.data}
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                }
                isOpen={openIndex === originalIdx}
                onClick={() => toggleFAQ(originalIdx)}
              />
            );
          })}
      </div>

      {/* Right Column */}
      <div className="flex flex-col gap-6 w-full md:w-1/2">
        {faqsList
          .filter((_, idx) => idx % 2 === 1)
          .map((product, mapIdx) => {
            const originalIdx = mapIdx * 2 + 1;
            return (
              <FAQButton
                key={originalIdx}
                question={product.question}
                answer={
                  <>
                    {product.answer && <p>{product.answer}</p>}
                    {Array.isArray(product.data) && product.data.length > 0 && (
                      <ul
                        style={{
                          fontSize: '1rem',
                          color: '#000',
                          fontFamily: "'Roboto', sans-serif",
                          lineHeight: '1.625',
                          margin: '0 0 10px',
                          paddingLeft: '40px',
                          listStyleType: 'decimal',
                        }}
                      >
                        {product.data.map((item, i) => (
                          <li key={i} style={{ marginBottom: '10px' }}>
                            <strong>{item.title}</strong> {item.data}
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                }
                isOpen={openIndex === originalIdx}
                onClick={() => toggleFAQ(originalIdx)}
              />
            );
          })}
      </div>
    </div>}





      
        {/* <div className="bg-white px-3 sm:px-10 py-10 lg:py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {faqsList.map((faqs, index) => (
              <div key={index}>
                <FAQButton
                  question={faqs.question}
                  answer={faqs.answer}
                  isOpen={openIndex === index}
                  onClick={() => toggleFAQ(index)}
                />
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default HomePageFaqsList;
